import React from 'react'
import Dashboard from '../../dashboard/index'
import ProfileView from './page'

const Profile = () => {
  return <Dashboard component={<ProfileView />} />
}

export default Profile
